import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './permission';


Vue.config.productionTip = false;

Vue.use(Antd);



window['dataLayer'] = window['dataLayer'] || [];

let head = document.querySelector('head') || {};

let script=document.createElement('script');
script.type='text/javascript';

script.innerHTML=`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TNMFD7Q');`;
head.appendChild(script);


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');